var $ = require('../internals/export');

// `Date.now` method
// https://tc39.github.io/ecma262/#sec-date.now
$({ target: 'Date', stat: true }, {
  now: function now() {
    return new Date().getTime();
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/irc-framework/node_modules/core-js/modules/es.date.now.js
// module id = rHEF
// module chunks = 0